import { Component, OnDestroy, OnInit, AfterViewInit, Output } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SchoolDetails } from "../../scp/schools/models";
import { PreferenceSet, PreferenceInstrumentClass } from "../../scp/preferences/models";
import * as fromServices from "../../scp/scp-common/services"
import * as fromStore from '../store';
import { Observable } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { FormControl, FormBuilder, FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';

@Component({
  selector: 'opus-reports-school-preferences',
  templateUrl: './reports-school-preferences.component.html'
})

export class ReportsSchoolPreferencesComponent implements OnInit, OnDestroy, AfterViewInit {
  private _alive = true;
  form: FormGroup;
  schoolId: number;
  school: SchoolDetails;
  schoolDetails$: Observable<SchoolDetails>;
  prefSet$: Observable<PreferenceSet>;
  selection: string;
  searchText: string;
 /* currentDate: Date;*/

  radioOptions = [
    { label: 'All', value: 'All' },
    { label: 'Band', value: 'Band' },
    { label: 'Orchestra', value: 'Orchestra' },
  ];

  constructor(private schoolService: fromServices.SchoolService,
            private prefsService: fromServices.PrefsService,
            private store: Store<fromStore.ReportPrefsResultsState>,
    private route: ActivatedRoute,
    private fb: FormBuilder) {
  }

  ngAfterViewInit(): void {
    const printFooter = document.getElementById("print-footer");
    if (printFooter) {
      printFooter.innerText = new Date().toLocaleDateString();
    }
  }
  ngOnInit(): void {
    this.schoolDetails$ = null;

    this.form = this.fb.group({
      selectedOption: ['All'],
    });

    this.selection = "All";

    this.schoolId = +this.route.snapshot.paramMap.get('id');
    if (this.schoolId > 0) {
      this.schoolDetails$ = this.schoolService.loadSchool(this.schoolId).pipe();
      this.prefSet$ = this.prefsService.loadPrefsBySchoolId(this.schoolId).pipe();
    }
  }

  ngOnDestroy(): void {
    this._alive = false;
  }

  onRadioChange(): void {
      const selectedValue = this.form.get('selectedOption').value;
      this.searchText = selectedValue;
    console.log('Selected Radio Button Value:', this.form.get('selectedOption').value);
  }

  get prefsFilter(): (o: any, val: string) => boolean {
    return (item: PreferenceInstrumentClass, val: string) => {
      const classFilter: string[] = ["OAA", "OAB", "OAC", "OAD"]; //Violin ,Viola, Cello, String Bass
      const p = item;

      val = val.toLowerCase();
      if (val == "all") {
        return true;
      }

      if (val == "band" && !classFilter.includes(item.preferenceInstrumentTypes[0].rentalCategory.code)) {
       return true;
      }

      if (val == "orchestra" && classFilter.includes(item.preferenceInstrumentTypes[0].rentalCategory.code)) {
        return true;
      }

      return false;

    };
  }
}
